























import moment from 'moment'
import OrderActionTableCell from '@/components/OrderActionTableCell.vue'
import { transportRequestStates as states } from '@/components/order-states'

export default {
  components: { OrderActionTableCell },
  props: {
    transportRequest: { type: Object, required: true },
    contactInfo: { type: Object, required: true },
    hSpan: { type: Number, default: 4 }
  },
  computed: {
    requestDetailsOnTooltip() {
      return `${this.$t('marketPlace.actionCell.orderStatus.tooltipSubmitted', {
        offerDate: this.requestCreatedDate,
        offerTime: this.requestCreatedTime
      })} 
      </br> 
      ${this.$t('marketPlace.actionCell.orderStatus.tooltipSennderContact')}${
        this.contactInfo.email
      }`
    },
    transporRequestText() {
      return this.requestIsRejected
        ? this.$t('marketPlace.actionCell.orderStatus.yourRejectedOffer', {
            offerPrice: `${this.transportRequest.price || 0} €`
          })
        : this.$t('marketPlace.actionCell.orderStatus.yourPendingOffer', {
            offerPrice: `${this.transportRequest.price || 0} €`
          })
    },
    requestIsRejected() {
      return this.transportRequest.state === states.rejected
    },
    requestIsWithdrawn() {
      return this.transportRequest.state === states.withdrawn
    },
    requestCreated() {
      return moment(this.transportRequest.created)
    },
    requestCreatedTime() {
      return this.requestCreated.format('HH:MM')
    },
    requestCreatedDate() {
      return this.requestCreated.format('DD.MM.YY')
    },
    requestInfoClasses() {
      return this.requestIsRejected ? 'label--rejected' : 'label--pending'
    },
    transportRequestPriceText() {
      const price = this.transportRequest.price
      return this.$t('marketPlace.actionCell.orderStatus.yourOffer', {
        offerPrice: price ? `${price} €` : ''
      })
    }
  }
}
